import React, { useEffect, useState } from 'react';
import {
  Box, Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
  MenuItem, Alert, Checkbox, Typography,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { blAPI } from '../services/api';
import { apiError, dateFr, BL_STATUS } from '../utils/format';
import { tokens } from '../theme';

const BonsLivraison = () => {
  const navigate = useNavigate();
  const { canCompta: canInvoice, isComptable } = useAuth();
  const [rows, setRows] = useState([]);
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(searchParams.get('statut') || '');
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    blAPI.list({ limit: 200, ...(status ? { status } : {}) })
      .then((r) => setRows(r.data.deliveries))
      .catch((err) => setError(apiError(err)));
  }, [status]);

  const facturable = (d) => d.status === 'VALIDEE' && !d.invoice_id;
  const selectedRows = rows.filter((r) => selected.includes(r.id));
  const sameClient = new Set(selectedRows.map((r) => r.client_id || r.client_name)).size <= 1;

  const toggle = (id) => setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <Layout title="Bons de livraison">
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        {!isComptable && <Button variant="contained" onClick={() => navigate('/pba-delivery')}>Nouveau bon de livraison</Button>}
        <TextField select size="small" label="Statut" value={status} onChange={(e) => setStatus(e.target.value)} sx={{ minWidth: 180 }}>
          <MenuItem value="">Tous</MenuItem>
          <MenuItem value="EN_COURS">Brouillons (à valider)</MenuItem>
          <MenuItem value="VALIDEE">Scellés</MenuItem>
          <MenuItem value="ANNULEE">Annulés</MenuItem>
        </TextField>
        {canInvoice && selected.length > 0 && (
          <>
            <Button variant="outlined" color="success" disabled={!sameClient}
              onClick={() => navigate(`/factures/nouvelle?bl=${selected.join(',')}`)}>
              Facturer {selected.length} BL
            </Button>
            {!sameClient && <Typography variant="caption" color="error">Sélectionnez des BL d'un même client</Typography>}
          </>
        )}
      </Box>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {canInvoice && <TableCell padding="checkbox" />}
              <TableCell>N° BL</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Destination</TableCell>
              <TableCell>Commande</TableCell>
              <TableCell align="right">Poteaux</TableCell>
              <TableCell>Validations</TableCell>
              <TableCell>Statut</TableCell>
              {canInvoice && <TableCell>Facture</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((d) => (
              <TableRow key={d.id} hover sx={{ cursor: 'pointer' }} onClick={() => navigate(`/bons-livraison/${d.id}`)}>
                {canInvoice && (
                  <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                    {facturable(d) && <Checkbox size="small" checked={selected.includes(d.id)} onChange={() => toggle(d.id)} />}
                  </TableCell>
                )}
                <TableCell sx={{ fontFamily: tokens.mono, fontWeight: 600, whiteSpace: 'nowrap' }}>{d.bl_numero || `#${d.id}`}</TableCell>
                <TableCell>{dateFr(d.delivery_date)}</TableCell>
                <TableCell>{d.client_name}</TableCell>
                <TableCell>{d.destination}</TableCell>
                <TableCell>{d.commande_ref}</TableCell>
                <TableCell align="right">{d.total_quantity}</TableCell>
                <TableCell>{d.status === 'ANNULEE' ? '—' : `${d.validations_count}/3`}</TableCell>
                <TableCell>
                  <Chip size="small" label={BL_STATUS[d.status]?.label || d.status} color={BL_STATUS[d.status]?.color || 'default'} />
                </TableCell>
                {canInvoice && <TableCell>{d.invoice_numero || (d.invoice_id ? 'Brouillon' : '')}</TableCell>}
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={10} align="center">Aucun bon de livraison</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Layout>
  );
};

export default BonsLivraison;
